// extracted by mini-css-extract-plugin
export var container = "Rules-module--container--hgNQQ";
export var subtitle = "Rules-module--subtitle--xSqiL";
export var title = "Rules-module--title--BOSlv";